export const getDaysNoun = (amount) => {
  let daysNoun = 'дней';

  if (amount < 10 || amount > 20) {
    switch (amount % 10) {
      case 1:
        daysNoun = 'день';
        break;
      case 2:
      case 3:
      case 4:
        daysNoun = 'дня';
        break;
    }
  }

  return daysNoun;
};
